export const getTopPosition = (elementId: string) => {
	const element = document.querySelector(`#${elementId}`);
	return element!.getBoundingClientRect().top + window.scrollY;
};
